'use strict';

var setters = require('../../render/utils/setters.cjs');
var addWillChange = require('../../value/use-will-change/add-will-change.cjs');
var getAppearId = require('../optimized-appear/get-appear-id.cjs');
var motionValue = require('./motion-value.cjs');
var getValueTransition = require('../../../../../../../motion-dom/dist/es/animation/utils/get-value-transition.cjs');
var frame = require('../../../../../../../motion-dom/dist/es/frameloop/frame.cjs');
var keysPosition = require('../../../../../../../motion-dom/dist/es/render/utils/keys-position.cjs');

/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */
function shouldBlockAnimation({ protectedKeys, needsAnimating }, key) {
    const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}
function animateTarget(visualElement, targetAndTransition, { delay = 0, transitionOverride, type } = {}) {
    let { transition = visualElement.getDefaultTransition(), transitionEnd, ...target } = targetAndTransition;
    if (transitionOverride)
        transition = transitionOverride;
    const animations = [];
    const animationTypeState = type &&
        visualElement.animationState &&
        visualElement.animationState.getState()[type];
    for (const key in target) {
        const value = visualElement.getValue(key, visualElement.latestValues[key] ?? null);
        const valueTarget = target[key];
        if (valueTarget === undefined ||
            (animationTypeState &&
                shouldBlockAnimation(animationTypeState, key))) {
            continue;
        }
        const valueTransition = {
            delay,
            ...getValueTransition.getValueTransition(transition || {}, key),
        };
        /**
         * If the value is already at the defined target, skip the animation.
         */
        const currentValue = value.get();
        if (currentValue !== undefined &&
            !value.isAnimating &&
            !Array.isArray(valueTarget) &&
            valueTarget === currentValue &&
            !valueTransition.velocity) {
            continue;
        }
        /**
         * If this is the first time a value is being animated, check
         * to see if we're handling off from an existing animation.
         */
        let isHandoff = false;
        if (window.MotionHandoffAnimation) {
            const appearId = getAppearId.getOptimisedAppearId(visualElement);
            if (appearId) {
                const startTime = window.MotionHandoffAnimation(appearId, key, frame.frame);
                if (startTime !== null) {
                    valueTransition.startTime = startTime;
                    isHandoff = true;
                }
            }
        }
        addWillChange.addValueToWillChange(visualElement, key);
        value.start(motionValue.animateMotionValue(key, value, valueTarget, visualElement.shouldReduceMotion && keysPosition.positionalKeys.has(key)
            ? { type: false }
            : valueTransition, visualElement, isHandoff));
        const animation = value.animation;
        if (animation) {
            animations.push(animation);
        }
    }
    if (transitionEnd) {
        Promise.all(animations).then(() => {
            frame.frame.update(() => {
                transitionEnd && setters.setTarget(visualElement, transitionEnd);
            });
        });
    }
    return animations;
}

exports.animateTarget = animateTarget;
//# sourceMappingURL=visual-element-target.cjs.map
